<template>
  <div class="ReportList">
    <AppHeader content="教学数据 | 交互报告"></AppHeader>
    <div class="titleBox">
      <b class="seriesBox">{{ detailTestInfo.classSubjectName }}</b>
      <div>
        <b>第{{ detailTestInfo.sortNumber }}课：</b
        >{{ detailTestInfo.lessonName }}
      </div>
    </div>
    <AppBox id="appBox" class="appBox">
      <XTable
        :api="getDataTestInfoList"
        :state="dataTestInfoList"
        :columns="columns"
        :loading="dataTestInfoListLoading"
        :tableSize="tableSize"
        :layout="layout"
        :firstColumn="firstColumn"
        :maxHeight="maxHeight"
      ></XTable>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import XTable from "@/components/XTable/index.vue";
import { mapActions, mapState } from "vuex";
import { MODULE_TYPE } from "@/utils/constants";
import DateUtil from "@/utils/formatDate";

export default {
  name: "ReportList",
  components: { XTable, AppBox, AppHeader },
  data() {
    const self = this;
    const columns = [
      {
        prop: "rootId",
        label: "内容序号",
      },
      {
        label: "内容属性",
        render(h, scope) {
          return (
            <div>
              <span>{MODULE_TYPE[scope.row.questionType]}</span>
            </div>
          );
        },
      },
      {
        label: "问题",
        render(h, scope) {
          return (
            <div>
              <span>{(scope.row && scope.row.questionTitle) || "-"}</span>
            </div>
          );
        },
      },
      {
        label: "参与人数",
        render(h, scope) {
          return (
            <div>
              <span>{(scope.row && scope.row.totalUser) || 0}</span>
            </div>
          );
        },
      },
      {
        label: "平均答题时长（秒）",
        render(h, scope) {
          return (
            <div>
              <span>{self.formatCostAvg(scope.row.costAvg)}</span>
            </div>
          );
        },
      },
      {
        label: "错题率",
        render(h, scope) {
          const errorRateCount = scope.row && scope.row.errorRate;
          return (
            <div>
              <span>
                {errorRateCount !== null
                  ? Math.round(`${errorRateCount}` * 100) + "%"
                  : "-"}
              </span>
            </div>
          );
        },
      },
      {
        label: "跳出率",
        render(h, scope) {
          const abortCount = scope.row && scope.row.abortPercent;
          return (
            <div>
              <span>
                {abortCount !== null
                  ? Math.round(`${abortCount}` * 100) + "%"
                  : "-"}
              </span>
            </div>
          );
        },
      },
    ];
    return {
      tableSize: "small",
      layout: "",
      firstColumn: true,
      maxHeight: null,
      columns: [...columns],
      detailTestInfo: {},
    };
  },
  computed: {
    ...mapState("dataCenter", ["dataTestInfoList", "dataTestInfoListLoading"]),
  },
  async mounted() {
    this.detailTestInfo = JSON.parse(localStorage.getItem("detailTestInfo"));
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapActions("dataCenter", ["getDataTestInfo"]),
    async getDataTestInfoList() {
      await this.getDataTestInfo({
        id: this.$route.params.id,
      });
    },
    //   根据时间戳计算上传时间
    formatCostAvg(timestamp) {
      return DateUtil.formatCostAvg(timestamp);
    },
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        this.maxHeight = el.offsetHeight - el.offsetHeight * 0.2;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ReportList {
  .titleBox {
    background: #ffffff;
    margin-bottom: 5px;
    padding: 20px;
    display: flex;
    align-items: center;

    .seriesBox {
      margin-right: 80px;
    }
  }

  .appBox {
    height: calc(100vh - 220px);
  }
}
</style>
